import getDestinationStorageKey from '@anm/components/stream/destination_management/helpers/getDestinationStorageKey';
import browserStore from '@anm/helpers/browserStore';
import useSwitchState from '@anm/hooks/useSwitchState';
import { userDestinationsSelectors } from '@anm/store/modules/userDestinations';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SocialDestination } from 'types/stream';

type HookProps = {
  destinations: SocialDestination[] | null;
};

const useNoDestinationsModal = ({ destinations }: HookProps) => {
  const [isNoDestinationModalOpened, openNoDestinationModal, closeNoDestinationsModal] = useSwitchState();
  const isFetched = useSelector(userDestinationsSelectors.selectDestinationsListIsFetched);

  useEffect(() => {
    if (destinations === null || isNoDestinationModalOpened || !isFetched) return;

    destinations.length === 0 && openNoDestinationModal();
  }, [destinations?.length, isFetched]);

  const closeModal = useCallback(() => {
    browserStore.remove(getDestinationStorageKey());
    closeNoDestinationsModal();
  }, []);

  return [isNoDestinationModalOpened, closeModal] as const;
};

export default useNoDestinationsModal;
